import React from 'react';
import { t } from '@lingui/core/macro';
import { useQuery } from '@tanstack/react-query';
import { ProjectDeadline } from '@/types';
import { getProjectDeadlines } from '@/services/projects';
import { Select } from '@ygtechnologies/bygr-frontend-component-library';

interface ProjectDeadlineSelectProps {
    projectId: number | null;
    onChange(deadlineId: number, deadline: ProjectDeadline): void;
    value: number | null;
    required?: boolean;
    isDisabled?: boolean;
}

export const ProjectDeadlineSelect: React.FC<ProjectDeadlineSelectProps> = ({
    projectId,
    onChange,
    value,
    required = false,
    isDisabled = false,
}) => {
    const { data: deadlines, isLoading } = useQuery({
        queryKey: ['projectDeadlines', projectId],
        queryFn: () => getProjectDeadlines(projectId!),
        enabled: !!projectId,
    });

    const deadlinesOptions = (deadlines ?? []).map((dl) => ({
        label: dl.name,
        value: dl.id,
        data: dl,
    }));

    return (
        <div>
            <Select
                isDisabled={isDisabled}
                isLoading={isLoading}
                required={required}
                fieldName={t`Deadline`}
                placeholder={t`Select deadline`}
                onChange={(nw: any) => onChange(nw.value, nw.data)}
                value={deadlinesOptions.find((dl) => dl.value === value) || null}
                options={deadlinesOptions}
            />
        </div>
    );
};
